export default "__VITE_ASSET__Cl0z8UkU__"